import PropTypes from 'prop-types';
import React from 'react';
import SvgIcon from './SvgIcon';
import SvgShadow from './SvgShadow';

const Star = props => (
    <div className={`lantern-star${props.isFilled ? ' star-on' : ''}`}>
        {props.withShadow && (
            <SvgShadow
                type="star"
                id={`star-shadow-${props.index}`}
                svgTitle={`Star shadow ${props.index}`}
                svgDescription={`Shadow for the star ${props.index} image`}
            />
        )}
        <SvgIcon
            class="svg-star lantern-svg"
            id="star"
            svgTitle={`Star ${props.index} icon`}
            svgDescription={`Assessment rate for star ${props.index}`}
            index={props.index}
        />
        <span className="star-label">{props.index}</span>
    </div>
);

Star.propTypes = {
    index: PropTypes.number.isRequired,
    isFilled: PropTypes.bool,
    withShadow: PropTypes.bool,
};

Star.defaultProps = {
    isFilled: false,
    withShadow: false,
};

export default Star;
